import type { ReactNode } from "react";
import * as T from "@radix-ui/react-tabs";
import { cn } from "@/lib/cn";

export function Tabs({
  value,
  onValueChange,
  tabs,
  children,
}: {
  value: string;
  onValueChange: (v: string) => void;
  tabs: { value: string; label: string }[];
  children: ReactNode;
}) {
  return (
    <T.Root
      value={value}
      onValueChange={onValueChange}
      className="flex flex-col flex-1 min-h-0"
    >
      <T.List className="flex gap-1 border-b border-border-subtle px-6 flex-shrink-0">
        {tabs.map((t) => (
          <T.Trigger
            key={t.value}
            value={t.value}
            className={cn(
              "px-3 py-2.5 text-sm font-medium -mb-px border-b-2 border-transparent text-text-secondary",
              "data-[state=active]:border-accent data-[state=active]:text-text-primary hover:text-text-primary",
            )}
          >
            {t.label}
          </T.Trigger>
        ))}
      </T.List>
      {children}
    </T.Root>
  );
}

export const TabPanel = T.Content;
